import React from 'react';
import {
   View,
   Image,
   Text,
   Dimensions,
   StyleSheet,
   Linking,
   TouchableOpacity,
   Platform,
   Modal,
} from 'react-native';
import {
   appBackground,
   drawerListBackgroundColor,
   FONT_FAMILY_REGULAR,
} from './utils';
import logger from './logger';

const {width} = Dimensions.get('window');

const email = 'support@norcat.org';

const handlePhoneNumberTap = phoneNumber => {
   if (Platform.OS === 'android' || Platform.OS === 'ios') {
      logger('Running on a real device');
      Linking.openURL(`tel:${phoneNumber}`);
   }
};

const handleEmailTap = () => {
   const mailtoUrl = `mailto:${email}`;
   Linking.openURL(mailtoUrl);
};

export const ActionSheetCourseSupport = ({
   isVisible,
   onclose,
   isLandscapeOrientation,
}) => {
   return (
      <Modal
         animationType="none"
         transparent={true}
         visible={isVisible}
         animationDuration={10}>
         <TouchableOpacity style={{flex: 1}} onPress={onclose}>
            <View
               style={{
                  flex: 1,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}>
               <View
                  style={{
                     position: 'absolute',
                     bottom: 0,
                     justifyContent: 'center',
                     alignItems: 'center',
                  }}>
                  <View
                     style={[
                        styles.container,
                        {height: Platform.OS === 'android' ? 308 : 297},
                     ]}>
                     <View
                        style={[
                           styles.background,
                           {height: Platform.OS === 'android' ? 308 : 297},
                        ]}>
                        <Text onPress={handleEmailTap} style={styles.email}>
                           {'Email: support@norcat.org'}
                        </Text>

                        <TouchableOpacity
                           onPress={() => handlePhoneNumberTap('705-521-8324')}>
                           <Text style={styles.phone}>
                              {'Phone: 705-521-8324'}
                           </Text>
                        </TouchableOpacity>

                        {isLandscapeOrientation ? (
                           <Text style={styles.address}>
                              {
                                 '1545 Maley Drive\n Greater Sudbury, ON, Canada\n P3A 4R7'
                              }
                           </Text>
                        ) : (
                           <Text style={styles.address}>
                              {
                                 '1545 Maley Drive,Greater Sudbury,\n ON, Canada P3A 4R7'
                              }
                           </Text>
                        )}

                        <Image
                           style={styles.logo}
                           source={require('../assets/norcat-logo_support.png')}
                        />

                        <Text style={styles.supportTitle}>
                           {'NORCAT TRAINING SUPPORT'}
                        </Text>

                        <View style={styles.lineView} />

                        <Text style={styles.headerTitle}>
                           {'Course Support'}
                        </Text>

                        <View style={styles.upperLineView} />
                     </View>
                  </View>
               </View>
            </View>
         </TouchableOpacity>
      </Modal>
   );
};

const styles = StyleSheet.create({
   container: {
      width: width,
      flexDirection: 'column-reverse',
      alignItems: 'center',
      justifyContent: 'center',
   },
   background: {
      backgroundColor: appBackground,
      width: width,
      borderTopRightRadius: 16,
      borderTopLeftRadius: 16,
      flexDirection: 'column-reverse',
   },
   email: {
      color: '#003DA5',
      textAlign: 'center',
      marginBottom: 30,
      fontSize: 14,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   phone: {
      color: 'black',
      textAlign: 'center',
      marginBottom: 20,
      fontSize: 14,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   address: {
      color: 'black',
      textAlign: 'center',
      marginBottom: 20,
      fontSize: 12,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   logo: {
      marginBottom: 20,
      justifyContent: 'center',
      alignSelf: 'center',
      width: 178,
      height: 24,
   },
   supportTitle: {
      textAlign: 'center',
      marginVertical: 20,
      color: drawerListBackgroundColor,
      fontSize: 12,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   lineView: {
      marginHorizontal: 16,
      height: 1,
      backgroundColor: '#000000',
      opacity: 0.2,
   },
   headerTitle: {
      textAlign: 'center',
      marginBottom: 17,
      color: drawerListBackgroundColor,
      fontSize: 16,
      fontWeight: '700',
      lineHeight: 22,
      fontFamily: FONT_FAMILY_REGULAR,
   },
   upperLineView: {
      marginHorizontal: 16,
      marginBottom: 15,
      height: 5,
      width: 56,
      backgroundColor: '#000000',
      opacity: 0.3,
      borderRadius: 100,
      alignSelf: 'center',
   },
});
